<template>
  <div class="wrap">
    <div class="card-wrap">
      <div class="card">
        <img class="img-coin" src="@/assets/image/evaluate/pic-coin@3x.png" />
        <div class="product-name">{{ title }}</div>
        <span class="text">{{ $t('PCModelList.index.totalPrice') }}</span>
        <div class="total-price">
          <div class="symbol">{{ symbol }}</div>
          <div class="price">{{ totalPrice }}</div>
        </div>
        <!-- 价格组合 -->
        <div class="price-combination">
          <!-- <div class="triangle"></div> -->
          <img class="triangle" src="../../../assets/image/evaluate/triangle.png" alt="" />
          <!-- 旧机 -->
          <div class="product-price">
            <div class="text">{{ $t('PCBottomButton.index.text2') }}</div>
            <div class="price">{{ symbol }}{{ price }}</div>
          </div>
          <div v-if="subsidy" class="add">+</div>
          <!-- 补贴 -->
          <div v-if="subsidy" class="subsidy-price">
            <div class="text">{{ $t('PCBottomButton.index.text3') }}</div>
            <div class="price">{{ symbol }}{{ subsidy }}</div>
          </div>
          <!-- 推广补贴 -->
          <div v-if="expertDiscount" class="add">+</div>
          <!-- 补贴 -->
          <div v-if="expertDiscount" class="subsidy-price">
            <div class="text">{{ $t('component.tradeInProcess.expertDiscount') }}</div>
            <div class="price">{{ symbol }}{{ expertDiscount }}</div>
          </div>
        </div>
      </div>
      <ul class="tips">
        <li>{{$t('PCModelInfo.index.64tve23zt0g0')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zup00')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zuy40')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zv7g0')}}</li>
      </ul>
    </div>

    <div class="card-wrap">
      <h5 class="title">{{$t('PCModelInfo.index.64tve23zvbg0')}}</h5>
      <p class="p-text">{{$t('PCModelInfo.index.64tve23zvf80')}}</p>
      <ul class="tips tips2">
        <li>{{$t('PCModelInfo.index.64tve23zvjc0')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zvms0')}}</li>
      </ul>

      <h5 class="title">{{$t('PCModelInfo.index.64tve23zvqg0')}}</h5>
     

      <ul class="contact-info contact-info2">
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zvyo0')"></li>
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zwak0')"></li>
      </ul>   
    </div>
    
    <div class="card-wrap">
      <h5 class="title">{{$t('PCModelInfo.index.64tve23zwgs0')}}</h5>
      <ul class="contact-info">
        <li class="p-text2">{{$t('PCModelInfo.index.64tve23zwm80')}}</li>
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zwt00')"></li>
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zsw1r')"></li>
      </ul>            

      <div class="plaint-text">
        {{$t('PCModelInfo.index.64tve23zwwk0')}}
      </div>
    </div>


   
  </div>
</template>

<script>
export default {
  name: 'wrapperImg',
  props: {
    title: {
      type: String,
      default: ''
    },
    price: {
      type: [Number, String],
      default: 0
    },
    symbol: {
      type: String,
      default: ''
    },
    subsidy: {
      type: [Number, String],
      default: 0
    },
    expertDiscount: {
      type: [Number, String],
      default: 0
    },
    activeMoney: {
      type: Object,
      default: function () {
        return {
          discountMoney: 0,
          subsidy: 0,
          totalMoney: 0,
          money: 0,
          isCurrent: false
        };
      }
    }
  },
  computed: {
    totalPrice() {
      return Number(this.price) + Number(this.subsidy) + Number(this.expertDiscount);
    }
  },
  methods: {}
};
</script>

<style scoped lang="less">
.wrap {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  padding-bottom: 50px;
  .card-wrap {
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 24px;

    .tips,
    .contact-info {
      padding: 24px 0 24px 60px;
      overflow: hidden;
      li {
        list-style-type: disc;
        color: var(--text-3, #8f949d);
        font-family: 'PingFang SC';
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      li:not(:last-child) {
        margin-bottom: 12px;
      }
    } 

    .contact-info {
      padding-top: 0;
      padding-bottom: 0;

      li {
        color: #252629;
      }
    }

    .contact-info2{
      margin-bottom: 30px;
    }

    .plaint-text {
      display: block;
      border-radius: 16px;
      background: #fbfbfb;
      color: var(--text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 150% */
      margin: 20px;
      padding: 20px;
    }

    .p-text {
      color: var(--text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-left: 24px;
      margin-bottom: 16px;
    }

    .tips2 {
      border-radius: 8px;
      background: #fbfbfb;
      margin: 0 20px;
    }

    .title {
      color: var(--text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 24px 24px 16px;
    }

    .notice {
      color: var(--text-2, #5d5f65);
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 0 24px 24px;
      span {
        display: block;
        margin: 16px 0;
      }
    }
  }
  .card {
    background: linear-gradient(to right, #4070FF, #405FFF);
    border-radius: 24px;
    min-height: 400px;
    position: relative;
    box-sizing: border-box;
    padding: 24px;
    box-sizing: border-box;
    .img-coin {
      width: 176px;
      height: 176px;
      position: absolute;
      top: 16px;
      right: 24px;
    }
    .product-name {
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 26px;
      max-width: 652px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .text {
      font-size: 28px;
      margin-bottom: 16px;
    }
    .total-price {
      display: flex;
      align-items: flex-end;
      margin-bottom: 32px;
      .symbol {
        font-size: 48px;
        font-weight: 700;
        margin-bottom: 8px;
      }
      .price {
        font-size: 72px;
        font-weight: 700;
      }
    }
    .price-combination {
      width: 100%;
      background: #fff;
      border-radius: 16px;
      position: relative;
      display: flex;
      align-items: center;
      .triangle {
        width: 32px;
        height: 16px;
        position: absolute;
        top: -16px;
        left: 64px;
      }
      .product-price,
      .subsidy-price {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 0;
        box-sizing: border-box;
        .text {
          color: #666;
          font-size: 24px;
          text-align: center;
        }
        .price {
          font-size: 36px;
          color: #333;
          font-weight: 500;
        }
      }
      .subsidy-price .price {
        color: #ff7b24;
      }
      .add {
        color: #999;
        font-size: 36px;
        font-weight: 500;
        // position: absolute;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
